<template>
  <v-virtual-scroll
    :items="myItems"
    item-height="56"
    class='overflow-x-hidden'
  >
    <template v-slot:default="{ item }">
      <v-row
        class="ma-0 ml-2 pa-0 customLine"
        align="center"
        justify="start"
        @click.stop="onSelect(item)"
        style="height: 56px !important;"
        :disabled="item._disabled">
        <v-badge
          :color="item._badgeColor"
          dot
          class="py-3 px-0">
        </v-badge>
        <v-col cols="2" class="pa-0" align="center">
          <v-badge
            overlap
            :color="item._unreadColor">
            <template v-slot:badge>
              <span slot='badge' class='text-no-wrap'>{{ item._unreadNumber }}</span>
            </template>
            <v-avatar size="32">
              <img v-if="item._avatar" :src='item._avatar'>
              <v-avatar v-else
                size="30"
                :color="item.color ? item.color : 'primary'">
                <span
                  class="font-weight-bold white--text"
                  style="font-size:23px; user-select: none; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {{ item._namePrefix }}
                </span>
              </v-avatar>
            </v-avatar>
          </v-badge>
        </v-col>
        <v-col cols="6" class="py-0" align="stat">
          <v-row align="center" justify="start">
            <v-col cols="12" class="pa-0 ma-0" align="start">
              <v-row class="ma-0" align="center" justify="start">
                <v-col v-if="item.chatShare == 'yes' || item.chatsShare" cols="1" class="pa-0" align="center">
                  <v-icon x-small color="success" class="white--text">mdi-earth</v-icon>
                </v-col>
                <v-col v-if="item.chatType == 'group' && item.classroom" cols="1" class="pa-0" align="center">
                  <v-icon x-small color="primary" class="white--text">mdi-school</v-icon>
                </v-col>
                <v-col v-if="item.chatType == 'group' && !item.classroom" cols="1" class="pa-0" align="center">
                  <v-icon x-small color="primary" class="white--text">mdi-chat</v-icon>
                </v-col>
                <v-col v-if="!item.public" cols="1" class="pa-0" align="center">
                  <v-icon x-small color="error" class="">mdi-lock</v-icon>
                </v-col>
                <v-col :cols="item._cols" class="pa-0" align="start">
                  <p class="ma-0 pa-0 overflow-text-hidden">{{ item.name }}</p>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="py-0" align="start">
              <v-row align-content="space-between">
                <v-col cols="8" class="pa-0" align="start">
                  <v-chip x-small outlined :color="item._schoolColor" class="hidden-sm-and-down">
                    <span class="text-overflow-hidden">{{ item._school }}</span>
                  </v-chip>
                </v-col>
                <v-col cols="4" class="pa-0" align="end">
                  <span style="font-size: 9px;">{{ item._date }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="item._statusDisplay" cols="2">
          <v-row class="ma-0">
            <v-btn
              x-small
              rounded
              depressed
              :color="item._statusColor"
              :disabled="item._statusDisable"
              @click.stop="onRequestDialog(item)"
            >
              <span>{{ item._statusTitle }}</span>
            </v-btn>
          </v-row>
        </v-col>
        <v-col v-else cols="2"></v-col>
        <v-col cols="2">
          <v-btn v-if="item._pinDisplay" icon small @click.stop="onPin(item)">
            <v-icon small :color="item._pinColor">{{ item._pinIcon }}</v-icon>
          </v-btn>
          <v-avatar v-if="mode == 'search'"
            size="24"
            color="primary">
            <span class="font-weight-bold white--text" style="font-size:14px; user-select: none;">
              {{ filteredCounts[item.key] }}
            </span>
          </v-avatar>
        </v-col>
      </v-row>
    </template>
    </v-virtual-scroll>
  <!-- </v-list> -->
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      chatRef: 'chatRef/chatRef',
      chatMessage: 'chatMessage/chatMessage',
      chatRefStatus: 'chatRefStatus/chatRef',
      shares: 'shares/shares',
      chatUnread: 'chatUnread/chatRef',
      publicGroups: 'publicGroups/groups',
      publicUsers: 'publicUsers/users',
      statuses: 'statuses/statuses'
    }),
    myItems () {
      var vm = this
      var temp = JSON.parse(JSON.stringify(this.items))
      for (var i in temp) {
        temp[i]['_status'] = this.getStatus(temp[i])
        temp[i]['_statusTitle'] = this.chatStatus[temp[i]['_status']].title
        temp[i]['_statusColor'] = this.chatStatus[temp[i]['_status']].color
        temp[i]['_statusDisable'] = this.chatStatus[temp[i]['_status']].disable
        temp[i]['_myStatus'] = this.myStatus(temp[i])
        temp[i]['_unreadNumber'] = this.unreadNumber(temp[i])
        temp[i]['_avatar'] = this.getAvatar(temp[i])
        temp[i]['_namePrefix'] = this.getNamePrefix(temp[i])
        temp[i]['_type'] = this.checkType(temp[i])
        temp[i]['_statusDisplay'] = this.mode !== 'search' && temp[i]['_type']
        temp[i]['_cols'] = this.getCols(temp[i])
        temp[i]['_school'] = this.getSchool(temp[i])
        temp[i]['_schoolColor'] = temp[i].chatType !== 'school' ? 'primary' : 'transparent'
        temp[i]['_date'] = this.getDate(temp[i])
        temp[i]['_pin'] = this.checkPin(temp[i])
        temp[i]['_pinColor'] = temp[i]['_pin'] ? 'primary' : 'grey'
        temp[i]['_pinIcon'] = temp[i]['_pin'] ? 'mdi-pin' : 'mdi-pin-outline'
        temp[i]['_pinDisplay'] = this.mode !== 'search' && temp[i]['_status'] === 'accepting'
        temp[i]['_disabled'] = temp[i]['_status'] === 'pending'
        temp[i]['_badge'] = temp[i]['_status'] === 'accepting' && temp[i].chatType === 'user'
        temp[i]['_badgeColor'] = temp[i]['_badge'] ? (temp[i]['_myStatus'] ? 'green accent-4' : 'grey lighten-2') : 'transparent'
        temp[i]['_unreadColor'] = temp[i]['_unreadNumber'] !== 0 ? 'error' : 'transparent'
      }
      temp.sort(function (a, b) {
        var ak = vm.chatStatus[vm.getStatus(a)].key
        var bk = vm.chatStatus[vm.getStatus(b)].key
        if (ak > bk) return 1
        if (ak < bk) return -1
        return 0
      })
      temp.sort(function (a, b) {
        var ak = vm.checkPin(a)
        var bk = vm.checkPin(b)
        if (ak > bk) return -1
        if (ak < bk) return 1
        return 0
      })
      return temp
    }
  },
  props: [ 'mode', 'items', 'selected', 'unReadGroup', 'unReadUser', 'filteredCounts', 'contentsHeight' ],
  data () {
    return {
      chatStatus: {
        'pending': { key: 3, icon: 'mdi-account-arrow-right', color: 'primary', disable: true, title: '承認待ち' },
        'requesting': { key: 2, icon: 'mdi-account-check', color: 'warning', disable: false, title: '承認' },
        'accepting': { key: 1, icon: 'mdi-logout', color: 'error', disable: false, title: '削除' },
        'none': { key: 4, icon: 'mdi-account-plus', color: 'success', disable: false, title: '登録' }
      },
      pins: []
    }
  },
  watch: {
    chatRefStatus () {
      var index = this.chatRefStatus.findIndex(c => c.key === this.user.uid)
      if (index !== -1) {
        this.pins = this.chatRefStatus[index].pins ? JSON.parse(JSON.stringify(this.chatRefStatus[index].pins)) : []
      } else {
        this.pins = []
      }
    }
  },
  created () {
    var index = this.chatRefStatus.findIndex(c => c.key === this.user.uid)
    if (index !== -1) {
      this.pins = this.chatRefStatus[index].pins ? JSON.parse(JSON.stringify(this.chatRefStatus[index].pins)) : []
    } else {
      this.pins = []
    }
  },
  methods: {
    myStatus (item) {
      var index = this.statuses.findIndex(status => status.key === item.key)
      if (index !== -1) {
        return this.statuses[index].state === 'online'
      }
      return false
    },
    unreadNumber (item) {
      if (typeof item === 'undefined') {
        return 0
      }
      if (typeof this.unReadUser[item.key] === 'undefined') {
        return 0
      }
      if (this.unReadUser[item.key] === null) {
        return 0
      }
      return this.unReadUser[item.key]
    },
    checkSchool (item) {
      if (!item.enable) {
        return false
      }
      if (item.public) {
        return true
      }
      if (item.chatType === 'school' && this.data.schools[item.key] === true) {
        return true
      }
      if (item.chatType === 'group' && this.data.groups[item.key] === true) {
        return true
      }
      return this.user.uid === item.owner
    },
    checkType (item) {
      if (this.getStatus(item) === 'accepting') {
        if (item.chatType === 'user') {
          return true
        }
        if (item.chatType === 'group' && !item.classroom && item.owner !== this.user.uid) {
          return true
        }
        return false
      }
      return true
    },
    getDate (item) {
      if (item.chatUpdate) {
        moment.tz.setDefault('Asia/Tokyo')
        return moment(item.chatUpdate).format('MM/DD')
      }
      return ''
    },
    getStatus (item) {
      var index = this.chatRef.findIndex(ref => ref.key === item.key)
      if (index !== -1) {
        return this.chatRef[index].status
      }
      // for (var i in this.chatRef) {
      //   if (this.chatRef[i].key === item.key) {
      //     return this.chatRef[i].status
      //   }
      // }
      return 'none'
    },
    getSchool (item) {
      for (var key in item.schools) {
        if (item.schools[key]) {
          var index = this.schools.findIndex(school => school.key === key)
          if (index !== -1) {
            return this.schools[index].name
          }
        }
      }
      return ''
    },
    getCols (item) {
      var cols = 12
      if (item.chatShare || item.chatsShare) {
        cols -= 1
      }
      if (item.chatType === 'group' && item.classroom) {
        cols -= 1
      }
      if (item.chatType === 'group') {
        cols -= 1
      }
      if (!item.public) {
        cols -= 1
      }
      return cols
    },
    getAvatar (item) {
      var url = null
      if (item.avatar) {
        url = item.avatar.thumbnail
      }
      return url
    },
    getNamePrefix (item) {
      var name = '？'
      if (item.name) {
        name = item.name.slice(0, 1)
      }
      return name
    },
    checkPin (item) {
      var index = this.pins.indexOf(item.key)
      return index !== -1
    },
    onPin (item) {
      var index = this.pins.indexOf(item.key)
      if (index !== -1) {
        this.pins.splice(index, 1)
      } else {
        this.pins.push(item.key)
      }
      const db = firebase.firestore()
      var ref = db.collection('chats_refs').doc(this.user.uid)
      ref.update({ pins: this.pins, updatedAt: parseInt(new Date().getTime()) }).then(function () {
      })
    },
    onSelect (item) {
      this.$emit('select', item)
    },
    onRequestDialog (item) {
      this.$emit('request', { item: item, id: item.chatType })
    }
  }
}
</script>

<style scoped>
img {
  object-fit: cover !important;
}
p {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  user-select: none !important;
}

.scroller {
  height: 100%;
}

.text-overflow-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.customLine {
  cursor: pointer;
  user-select: none;
}
.customLine:hover {
  background-color: #CCCCCC20;
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 8px;
}
</style>
